const STORAGE_KEY = 'authToken';
const CAPACITOR_STORAGE_KEY = 'CapacitorStorage.authToken';

class AuthTokenUtil {
  private authToken: string | null = null;

  constructor() {
    // Preference adds prefix to storage key, migrating the old key here
    const localAuthToken = localStorage.getItem(STORAGE_KEY);
    if (localAuthToken) {
      this.set(localAuthToken);
      localStorage.removeItem(STORAGE_KEY);
    } else {
      const capacitorAuthToken = localStorage.getItem(CAPACITOR_STORAGE_KEY);
      this.authToken = capacitorAuthToken;
    }
  }

  set(token: string) {
    this.authToken = token;
    localStorage.setItem(CAPACITOR_STORAGE_KEY, token);
  }

  get() {
    return this.authToken;
  }

  remove() {
    this.authToken = null;
    localStorage.removeItem(CAPACITOR_STORAGE_KEY);
  }
}

export default new AuthTokenUtil();
